import { useState, useEffect } from 'react';
import { Button, Link } from '@mui/material';

import { getToken, verify, responseVerify } from '../api/payment';
import { pb } from '../utilities/pocketbase';
import CRRaoAIMSCSLogo from '../crrao_aimscs_logo-min.png';

import DownloadIcon from '@mui/icons-material/Download';

export default function Payment(props) {
    const [tokenData, setTokenData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [downloadLink, setDownloadLink] = useState("");

    useEffect(() => {
        if (props.registrationId && props.registrationId.length === 15) {
            getToken(props.registrationId).then(response => {
                console.log("response:", response)
                setTokenData(response.data)
            }).catch(error => {
                console.log("error:", error)
            })
        }

    }, [props.registrationId, refresh])

    useEffect(() => {
        console.log("tokenData:", tokenData)
    }, [tokenData])

    function handleResponse(res) {
        if (typeof res != "undefined" && typeof res.paymentMethod != "undefined" && typeof res.paymentMethod.paymentTransaction != "undefined" && typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" && res.paymentMethod.paymentTransaction.statusCode == "0300") {
            // success block
            console.log("---------- SUCCESS BLOCK ----------")
            console.log("payment success response: ", res)
            const { id, transactionId } = tokenData
            const { merchantResponseString } = res

            if (id && transactionId) {
                const responseData = {
                    profile: id,
                    transactionid: transactionId,
                    transactioninfo: res,
                    status: "success",
                }

                responseVerify(merchantResponseString).then(response => {
                    console.log("response string verify check response: ", response.data, response.data?.verified)
                    if (response.data?.verified) {
                        pb.collection('payments').create({ ...responseData, verified: true }).then(paymentInfo => {
                            console.log("payment success created: ", paymentInfo)
                            if (paymentInfo?.id) {
                                try {
                                    const minPayInfo = {
                                        referenceId: minPayInfo?.id,
                                        registrationId: minPayInfo?.profile,
                                        transactionId: minPayInfo?.transactionid,
                                        status: minPayInfo?.status,
                                        created: minPayInfo?.created,
                                    }

                                    const minPayInfoString = `
referenceId    : ${minPayInfo?.id}
registrationId : ${minPayInfo?.profile}
transactionId  : ${minPayInfo?.transactionid}
status         : ${minPayInfo?.status}
created        : ${minPayInfo?.created}
`
                                    const json = JSON.stringify(minPayInfo, null, 2);
                                    const blob = new Blob([json], { type: "application/json" });
                                    const blobText = new Blob([minPayInfoString], { type: "application/text" });
                                    const href = URL.createObjectURL(blobText);
                                    const aLink = document.createElement("a")
                                    aLink.href = href
                                    aLink.download = `${paymentInfo?.id + " - "}PaymentDetails.txt`
                                    aLink.click()
                                    setDownloadLink(href)
                                } catch (e) {
                                    console.log("JSON Stringify failed!", e)
                                }
                            }
                            // const { transactionid } = paymentInfo
                            // verify(transactionid).then(response => {
                            //     console.log("verify check response: ", response.data, response.data?.verified)
                            // }).catch(error => {
                            //     console.log("verify check error: ", error)
                            // })
                            props?.setSuccess("Payment successful")
                            if (window.localStorage) {
                                window.localStorage.removeItem("registrationInfo")
                            }
                            props?.setActiveStep(2)
                        }).catch(error => {
                            console.log("payment success create error: ", error)
                        })
                    }
                }).catch(error => {
                    console.log("response string verify check error: ", error)
                    pb.collection('payments').create({ ...responseData, verified: false }).then(paymentInfo => {
                        console.log("payment success created: ", paymentInfo)
                        if (paymentInfo?.id) {
                            try {
                                const minPayInfo = {
                                    referenceId: minPayInfo?.id,
                                    registrationId: minPayInfo?.profile,
                                    transactionId: minPayInfo?.transactionid,
                                    status: minPayInfo?.status,
                                    created: minPayInfo?.created,
                                }

                                const minPayInfoString = `
referenceId    : ${minPayInfo?.id}
registrationId : ${minPayInfo?.profile}
transactionId  : ${minPayInfo?.transactionid}
status         : ${minPayInfo?.status}
created        : ${minPayInfo?.created}
`
                                const json = JSON.stringify(minPayInfo, null, 2);
                                const blob = new Blob([json], { type: "application/json" });
                                const blobText = new Blob([minPayInfoString], { type: "application/text" });
                                const href = URL.createObjectURL(blobText);
                                const aLink = document.createElement("a")
                                aLink.href = href
                                aLink.download = `${paymentInfo?.id + " - "}PaymentDetails.txt`
                                aLink.click()
                                setDownloadLink(href)
                            } catch (e) {
                                console.log("JSON Stringify failed!", e)
                            }
                        }
                        // const { transactionid } = paymentInfo
                        // verify(transactionid).then(response => {
                        //     console.log("verify check response: ", response.data, response.data?.verified)
                        // }).catch(error => {
                        //     console.log("verify check error: ", error)
                        // })
                    }).catch(error => {
                        console.log("payment success create error: ", error)
                    })
                })
            }
        } else if (typeof res != "undefined" && typeof res.paymentMethod != "undefined" && typeof res.paymentMethod.paymentTransaction != "undefined" && typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" && res.paymentMethod.paymentTransaction.statusCode == "0398") {
            // initiated block
            console.log("---------- INITIATED BLOCK ----------")
            console.log("payment INITIATED response: ", res)
        } else {
            // error block
            console.log("---------- ERROR BLOCK ----------")
            const { id, transactionId } = tokenData
            if (id && transactionId) {
                const responseData = {
                    profile: id,
                    transactionid: transactionId,
                    transactioninfo: res,
                    status: "error",
                    verified: false
                }

                pb.collection('payments').create(responseData).then(paymentInfo => {
                    console.log("payment error created: ", paymentInfo)
                }).catch(error => {
                    console.log("payment error create error: ", error)
                })
            }
        }
    };

    const handlePaymentSubmit = (e) => {
        props?.setSuccess("")
        setRefresh(ps => !ps)
        const { id, deviceId, transactionId, email, mobile, token, totalAmount } = tokenData
        if (id && deviceId && transactionId && token && totalAmount) {
            var reqJson = {
                "features": {
                    "enableAbortResponse": true,
                    "enableExpressPay": true,
                    "enableInstrumentDeRegistration": true,
                    "enableMerTxnDetails": true,
                    "enableNewWindowFlow": true    //for hybrid applications please disable this by passing false
                },
                "consumerData": {
                    "deviceId": deviceId,    //possible values "WEBSH1" or "WEBSH2"
                    "token": `${token}`,
                    // "returnUrl": "https://pgproxyuat.in.worldline-solutions.com/linuxsimulator/MerchantResponsePage.jsp",    //merchant response page URL
                    "responseHandler": handleResponse,
                    "paymentMode": "all",
                    "merchantLogoUrl": CRRaoAIMSCSLogo,  //provided merchant logo will be displayed
                    "merchantId": `${process.env.REACT_APP_WORLD_LINE_MERCHANT_CODE}`,
                    "merchantMsg": "14th Statistics Olympiad 2024 • CR Rao AIMSCS",
                    "currency": "INR",
                    "consumerId": `${id}`,
                    ...(mobile && { "consumerMobileNo": `${mobile}` }),
                    ...(email && { "consumerEmailId": `${email}` }),
                    "txnId": `${transactionId}`,   //Unique merchant transaction ID
                    "items": [{
                        "itemId": "first",
                        "amount": totalAmount,
                        "comAmt": "0"
                    }],
                    "customStyle": {
                        "PRIMARY_COLOR_CODE": "#90caf9",   //merchant primary color code
                        "SECONDARY_COLOR_CODE": "rgba(255, 255, 255, 0.7)",   //provide merchant's suitable color code
                        "BUTTON_COLOR_CODE_1": "#ffa726",   //merchant's button background color code
                        "BUTTON_COLOR_CODE_2": "#FFFFFF"   //provide merchant's suitable color code for button text
                    }
                }
            };

            console.log("reqJson: ", reqJson)

            window.$.pnCheckout(reqJson);
            if (reqJson.features.enableNewWindowFlow) {
                window.pnCheckoutShared.openNewWindow();
            }
        }
    }

    return (
        <>
            {(tokenData?.id && tokenData?.transactionId && tokenData?.token) && <Button
                disabled={props.disabled || props?.registrationId.length !== 15 || !tokenData?.id || !tokenData?.transactionId || !tokenData?.token}
                // id="btnSubmit"
                onClick={(e) => { handlePaymentSubmit(e) }}
                variant="contained" size="large" color='warning' sx={{ py: 2 }} fullWidth>
                Pay
            </Button>}
            {/* {!downloadLink && <Button startIcon={<DownloadIcon />} component={Link} download={`PaymentDetails.json`} href={downloadLink} color='warning' sx={{ textTransform: "none" }}>
                Download Payment info
            </Button>} */}
        </>
    )
}